(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-multi-level-selector/h-inner-level-selector.component.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"list-wrapper d-flex\">\n    ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"levels");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("level", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        ";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("parentIndex", t_5, true);
if(frame.topLevel) {
context.setVariable("parentIndex", t_5);
}
if(frame.topLevel) {
context.addExport("parentIndex", t_5);
}
output += "\n        <div class=\"list\"\n             style=\"width: ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"levels")),"length") > 0?100 / runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"levels")),"length"):0), env.opts.autoescape);
output += "%\">\n            <div class=\"list-inner\">\n                <div class=\"scrollable\"\n                     id=\"scrollable_";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "parentIndex"), env.opts.autoescape);
output += "\">\n                    ";
frame = frame.push();
var t_8 = t_4;
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("optn", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
output += "\n                        ";
if((lineno = 9, colno = 58, runtime.callWrap(runtime.memberLookup(((env.getFilter("lower").call(context, runtime.memberLookup((t_9),"label")))),"indexOf"), "--expression--[\"indexOf\"]", context, [env.getFilter("lower").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"searchText"))])) > -1) {
output += "\n                            <div class=\"multi-level-selector-checkbox ";
if(runtime.memberLookup((t_9),"disabled")) {
output += "disabled";
;
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"clickedOptions")),runtime.memberLookup((t_9),"level")) == runtime.memberLookup((t_9),"id") && runtime.memberLookup((t_9),"hasChilds") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewOnly")) {
output += " clicked";
;
}
output += "\" automation=\"multi-level-selector-checkbox\">\n                            ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewOnly")) {
output += "\n                                <div class=\"multi-level-selector-checkbox-icon ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"singleSelect") && runtime.memberLookup((t_9),"selectedByParent")) {
output += "selected-by-parent";
;
}
output += "\">\n                                    <label class=\"icon-label\" automation=\"multiLevelSelectorCheckboxLabel\" >\n                                        ";
if(runtime.memberLookup((t_9),"checked") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"CHECKED_VALUE")),"FULL")) {
output += "\n                                            <i class=\"fa fa-check-square\" role=\"checkbox\" aria-label=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"label"), env.opts.autoescape);
output += " checkbox\" ";
if(runtime.memberLookup((t_9),"selected")) {
output += "aria-checked=\"true\"";
;
}
else {
output += "aria-checked=\"false\"";
;
}
output += "\"></i>\n                                            ";
;
}
else {
if(runtime.memberLookup((t_9),"checked") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"CHECKED_VALUE")),"PARTIAL")) {
output += "\n                                            <i class=\"fa fa-minus-square-o\" role=\"checkbox\" aria-label=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"label"), env.opts.autoescape);
output += " checkbox\" ";
if(runtime.memberLookup((t_9),"selected")) {
output += "aria-checked=\"true\"";
;
}
else {
output += "aria-checked=\"false\"";
;
}
output += "\"></i>\n                                        ";
;
}
else {
output += "\n                                            <i class=\"fa fa-square-o\" role=\"checkbox\" aria-label=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"label"), env.opts.autoescape);
output += " checkbox\" ";
if(runtime.memberLookup((t_9),"selected")) {
output += "aria-checked=\"true\"";
;
}
else {
output += "aria-checked=\"false\"";
;
}
output += "\"></i>\n                                        ";
;
}
;
}
output += "\n                                        <input\n                                            type=\"checkbox\"\n                                            value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_9),"id"), env.opts.autoescape);
output += "\"\n                                            data-parent-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "parentIndex"), env.opts.autoescape);
output += "\"\n                                            data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\"\n                                            ";
if(runtime.memberLookup((t_9),"disabled")) {
output += "disabled='disabled'";
;
}
output += "\n                                            ";
if(runtime.memberLookup((t_9),"selected")) {
output += "checked=\"checked\"";
;
}
output += "\n                                        />\n                                    </label>\n                                </div>\n                            ";
;
}
output += "\n                                <div class=\"multi-level-selector-checkbox-label\" data-parent-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "parentIndex"), env.opts.autoescape);
output += "\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" automation=\"multi-level-selector-checkbox-label\">\n                                <span automation=\"multi-level-selector-checkbox-span\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_9),"label"), env.opts.autoescape);
output += "\n                                </span>\n                                    ";
if(runtime.memberLookup((t_9),"hasChilds") && !runtime.memberLookup((t_9),"loading")) {
output += "\n                                        <i class=\"arrow-icon fa fa-chevron-right transform-direction\"></i>\n                                    ";
;
}
output += "\n                                    ";
if(runtime.memberLookup((t_9),"loading")) {
output += "\n                                        <i class=\"arrow-icon fa fa-spinner fa-spin\"></i>\n                                    ";
;
}
output += "\n                                </div>\n                            </div>\n                        ";
;
}
output += "\n                    ";
;
}
}
frame = frame.pop();
output += "\n                </div>\n            </div>\n\n        </div>\n    ";
;
}
}
frame = frame.pop();
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
